import React from 'react'
import { ProjectFilters as ProjectFiltersType } from '../../types'

interface ProjectFiltersProps {
  filters: ProjectFiltersType
  onFiltersChange: (filters: ProjectFiltersType) => void
  onCreateProject: () => void
}

const ProjectFilters: React.FC<ProjectFiltersProps> = ({
  filters,
  onFiltersChange,
  onCreateProject
}) => {
  const handleSearchChange = (search: string) => {
    onFiltersChange({ ...filters, search })
  }

  const handleStatusChange = (isActive: boolean | undefined) => {
    onFiltersChange({ ...filters, isActive })
  }

  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between mb-6">
      {/* 左側：搜尋和篩選 */}
      <div className="flex flex-col sm:flex-row gap-4 flex-1">
        {/* 搜尋框 */}
        <div className="relative flex-1 max-w-md">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              className="h-5 w-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          <input
            type="text"
            value={filters.search || ''}
            onChange={(e) => handleSearchChange(e.target.value)}
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm"
            placeholder="搜尋專案名稱或描述..."
          />
        </div>

        {/* 狀態篩選 */}
        <div className="flex items-center space-x-2">
          <span className="text-sm text-secondary-600 whitespace-nowrap">狀態：</span>
          <select
            value={filters.isActive === undefined ? 'all' : filters.isActive ? 'active' : 'inactive'}
            onChange={(e) => {
              const value = e.target.value
              handleStatusChange(
                value === 'all' ? undefined : value === 'active'
              )
            }}
            className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm"
          >
            <option value="all">全部</option>
            <option value="active">進行中</option>
            <option value="inactive">已停用</option>
          </select>
        </div>
      </div>

      {/* 右側：建立按鈕 */}
      <button
        onClick={onCreateProject}
        className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 focus:ring-2 focus:ring-primary-500 transition-colors text-sm font-medium whitespace-nowrap"
      >
        <svg
          className="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 4v16m8-8H4"
          />
        </svg>
        建立專案
      </button>
    </div>
  )
}

export default ProjectFilters
